// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Css for pre-order campaign feature */
/* -- management page -- */
.BC-Page__Pre-Order-CampaignManagement .BC-Filters {
  padding: 20px;
  border-bottom: var(--p-border-divider);
  display: grid;
  gap: 10px;
}

.BC-PreOder--Filters {
  display: flex;
  gap: 8px;
}

.BC-PreOder--Filters .search {
  flex: 1 1 auto;
}

.BC-PreOder--Filters--Popover {
  width: 276px;
  height: 100%;
}

.BC-PreOder--Filters--Popover .Polaris-ChoiceList__Title,
.BC-PreOder--Filters--Popover .Polaris-Label__Text {
  font-weight: 500;
}

.BC-PreOder--Filters--Popover .Polaris-ChoiceList__Title,
.BC-PreOder--Filters--Popover .Polaris-Labelled__LabelWrapper {
  margin-bottom: 8px;
}

.BC-PreOder--Filters--Popover ul {
  display: flex;
  gap: 20px;
}

.BC-PreOder--Filters--Popover .breakLine {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 16px;
}

.list-campaigns {
  padding: 0;
}

.list-campaigns td {
  padding: 20px;
}

.list-campaigns .Polaris-Button--plain svg {
  fill: var(--p-icon);
}

.list-campaigns .Polaris-Badge {
  padding: 2px 8px;
  border-radius: 8px;
  width: 54px;
  display: flex;
  justify-content: center;
  text-align: center;
  font-weight: 500;
}

.list-campaigns .Polaris-Badge--statusAttention {
  background: rgba(255, 214, 164, 1);
  color: rgba(94, 66, 0, 1);
}

.list-campaigns .Polaris-Badge--statusNew {
  color: rgba(97, 97, 97, 1);
}

.list-campaigns .Polaris-Badge--statusInfo {
  background: rgba(224, 240, 255, 1);
  color: rgba(0, 82, 124, 1);
}

.list-campaigns table tbody tr:not(:first-child) td {
  border-top: var(--p-border-divider);
}

.BC-Page__Pre-Order-CampaignManagement [aria-label='Pagination'] {
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.BC-Page__Pre-Order-CampaignManagement .Polaris-PageActions {
  margin-top: 24px;
  border-top: none;
}

.BC-Page__Pre-Order-CampaignManagement .pfs-banner-detail .pfs-banner-content {
  width: 63% !important;
}

.preOrderGuideBanner .pfs-banner-detail .image {
  margin-left: 20px !important;
  margin-top: -20px !important;
}

.preOrderGuideBanner.pfs-banner-detail .image img {
  margin-top: -20px;
  max-width: 208px;
}

@media (max-width: 708px) {
  .preOrderGuideBanner .pfs-banner-content > div:first-child {
    min-height: 130px !important;
  }
}

@media (max-width: 619px) {
  .preOrderGuideBanner .pfs-banner-content > div:first-child {
    min-height: 150px !important;
  }
}

@media (max-width: 455px) {
  .preOrderGuideBanner .pfs-banner-content > div:first-child {
    min-height: 170px !important;
  }
}

@media (max-width: 423px) {
  .preOrderGuideBanner .pfs-banner-content > div:first-child {
    min-height: 200px !important;
  }
}

.BC-Page__Pre-Order-CampaignManagement .pfs-feature-lock-card {
  padding: 50px 93px;
  margin: unset;
}

.BC-EmptySearch__PreOrder {
  text-align: center;
  padding: 80px 112px;
}

.BC-EmptySearch__PreOrder img {
  max-width: 45px;
  height: auto;
  margin-bottom: 16px;
}
/* -- view page -- */

.PreOrder-Campaign__GeneralSettings .text-subdued {
  font-size: 14px;
  color: rgba(109, 113, 117, 1);
  margin-top: 4px;
}

.BC-Page__Pre-Order-CampaignItem .render-choice-2 .Polaris-ChoiceList__Choices li {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  padding: 5px 0;
}

.BC-Page__Pre-Order-CampaignItem
  .render-choice-2
  .Polaris-ChoiceList__Choices
  .Polaris-ChoiceList__ChoiceChildren {
  margin-bottom: unset;
}
.BC-Page__Pre-Order-CampaignItem .Polaris-SkeletonPage__Page {
  margin-top: 52px;
}

.BC-Page__Pre-Order-CampaignItem
  .Polaris-SkeletonPage__Page
  .Polaris-SkeletonDisplayText__DisplayText {
  margin-bottom: 20px;
}

.BC-Page__Pre-Order-CampaignItem .render-choice-2 {
  padding-bottom: 0;
}

.PreOrder-Campaign__GeneralSettings .settings {
  display: grid;
  gap: 24px;
}

.PreOrder-Campaign__GeneralSettings .settings .content {
  padding: 4px 16px 0;
  display: grid;
  gap: 8px;
}

.PreOrder-Campaign__GeneralSettings .Polaris-ChoiceList ul li {
  margin-top: 4px;
}

.PreOrder-Campaign__GeneralSettings .product-settings {
  display: flex;
  gap: 12px;
}

.PreOrder-Campaign__GeneralSettings .settings .stock-condition .Polaris-Connected {
  width: 30%;
  margin-top: 8px;
}
.PreOrder-Campaign__GeneralSettings .product-settings > div:first-child {
  width: 35%;
}

.PreOrder-Campaign__GeneralSettings .product-settings > div:last-child {
  flex: 1 1 auto;
}

.PreOrder-Campaign__GeneralSettings .product-list {
  border: 1px dashed rgba(225, 227, 229, 1);
  border-radius: 8px;
  position: relative;
}

.PreOrder-Campaign__GeneralSettings .product-list .show-more {
  border: unset !important;
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
  height: 56px;
}

.PreOrder-Campaign__GeneralSettings .product-list .show-more .Polaris-Button {
  height: 40px;
  background-color: #ffffff;
}

.PreOrder-Campaign__GeneralSettings .product-list .show-less {
  height: 56px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.PreOrder-Campaign__GeneralSettings .product-list .show-less .Polaris-Button__Content,
.PreOrder-Campaign__GeneralSettings .product-list .show-more .Polaris-Button__Content {
  color: #2c6ecb;
}

.PreOrder-Campaign__GeneralSettings .product-list > div:not(:first-child) {
  border-top: var(--p-border-divider);
}

.PreOrder-Campaign__GeneralSettings .product-list .product-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
}

.PreOrder-Campaign__GeneralSettings .product-list .product-item__Thumbnail,
.PreOrder-Campaign__GeneralSettings .product-list .product-item__Action {
  display: flex;
  align-items: center;
  gap: 16px;
}

.PreOrder-Campaign__PaymentAndDiscount .settings {
  display: grid;
  gap: 24px;
}

.PreOrder-Campaign__PaymentAndDiscount .settings .content {
  padding: 4px 16px 0;
  display: grid;
  gap: 8px;
}

.PreOrder-Campaign__PaymentAndDiscount .settings .content .row {
  display: flex;
  gap: 24px;
}

.PreOrder-Campaign__PaymentAndDiscount .settings .content .row-discount {
  align-items: end;
}

.PreOrder-Campaign__PaymentAndDiscount .settings .content .row > div:first-child {
  width: 35%;
}

.PreOrder-Campaign__PaymentAndDiscount .settings .content .row.one-column > div:first-child {
  width: 100%;
}

.PreOrder-Campaign__PaymentAndDiscount .settings .content .row.two-column > div:nth-child(2) {
  width: 180px;
  max-width: 180px;
}

.PreOrder-Campaign__PaymentAndDiscount .settings .content .one-column > div > div:nth-child(2) {
  width: 35%;
}

.PreOrder-Campaign__PaymentAndDiscount .date-select .Polaris-Button__Content {
  position: relative;
}
.PreOrder-Campaign__PaymentAndDiscount .date-select button {
  padding-right: 15px;
}
.PreOrder-Campaign__PaymentAndDiscount .date-select .Polaris-Button__Text {
  display: flex;
  align-items: center;
}

.PreOrder-Campaign__PaymentAndDiscount .date-select .Polaris-Button__Text > svg {
  position: absolute;
  right: 0;
  width: 6px;
  height: 12px;
}

.BC-PreOrderItem__Placement .Polaris-Link {
  display: inline-flex;
  gap: 2px;
  color: #2c6ecb;
}

.BC-PreOrderItem__Placement .Polaris-Link .Polaris-Icon {
  margin: 0;
  width: 16px;
  height: 16px;
}

.BC-PreOrderItem__Placement .heading {
  display: grid;
  gap: 12px;
}

.BC-PreOrderItem__Placement .heading .Polaris-Badge {
  padding: 2px 8px;
  height: 20px;
  border-radius: 8px;
}

.BC-PreOrderItem__Placement .heading > p:first-child {
  font-size: 28px;
  line-height: 32px;
  font-weight: 600;
}

.BC-PreOrderItem__Placement .heading > p:last-child {
  font-size: 20px;
  line-height: 28px;
  font-weight: 600;
}

.BC-PreOrderItem__Placement .setup-content,
.BC-PreOrderItem__Placement .Polaris-Card__Section {
  display: grid;
  gap: 32px;
}

.BC-PreOrderItem__Placement .action .content,
.BC-PreOrderItem__Placement .action {
  margin-top: 16px;
}

.BC-PreOrderItem__Placement .action .non-action {
  display: flex;
  gap: 12px;
}

.BC-PreOrderItem__Placement .action .non-action .Polaris-Icon {
  margin: unset;
}

.BC-PreOrder--ProductModal li {
  display: flex;
  justify-content: space-between;
}

.BC-PreOrder--ProductModal .list-available {
  padding-right: 10px;
}

.BC-PreOrder--ProductModal .list-available .variant {
  padding-left: 28px;
  margin-bottom: 12px;
}
.BC-PreOrder--ProductModal .list-available .variant li {
  padding: 10px 0;
}

.BC-PreOrder--ProductModal .list-available .variant .BC-ProductItem__Checkbox {
  display: flex;
  position: relative;
  top: 1px;
}

.BC-PreOrder--ProductModal .list-available .BC-ProductItem__Checkbox .Polaris-Choice__Control {
  margin-right: 0;
}

.PreOrder-Campaign__GeneralSettings .product-list .variant .product-item {
  border-top: var(--p-border-divider);
}

.PreOrder-Campaign__GeneralSettings .product-list .product-item__Action svg {
  fill: #8c9196;
}

/* general settings */
.BC-Page__PreOrderGeneralSettings .pfs-banner-detail .image {
  margin-top: -14px;
}

.BC-Page__PreOrderGeneralSettings .general-settings {
  border: 1px solid #e1e3e5;
  border-radius: 8px;
  width: 100%;
  background-color: #ffffff;
}

.BC-Page__PreOrderGeneralSettings .general-settings .pfs-feature-lock-card {
  margin: 60px;
}

.BC-Page__PreOrderGeneralSettings .general-settings .pfs-feature-lock-card .content {
  display: flex;
  justify-content: center;
}

.BC-Page__PreOrderGeneralSettings .general-settings .heading,
.BC-Page__PreOrderGeneralSettings .general-settings .content {
  display: flex;
  width: 100%;
}

.BC-Page__PreOrderGeneralSettings .general-settings .heading > div,
.BC-Page__PreOrderGeneralSettings .general-settings .content > div {
  width: 50%;
}

.BC-Page__PreOrderGeneralSettings .general-settings .heading > div:first-child,
.BC-Page__PreOrderGeneralSettings .general-settings .content > div:first-child {
  border-right: 1px solid #e1e3e5;
}

.BC-Page__PreOrderGeneralSettings .general-settings .content > div {
  height: 444px;
}

.BC-Page__PreOrderGeneralSettings .general-settings .heading > div {
  padding: 18px 20px;
  display: flex;
  line-height: 24px;
  align-items: center;
  border-bottom: 1px solid #e1e3e5;
}

.BC-Page__PreOrderGeneralSettings .heading > div:first-child {
  font-size: 14px;
  font-weight: 500;
}

.BC-Page__PreOrderGeneralSettings .display-settings {
  padding: 16px 20px;
}

.BC-Page__PreOrderGeneralSettings .display-settings .Polaris-Choice {
  margin-top: 15px;
}
.BC-Page__PreOrderGeneralSettings .display-settings > div:last-child {
  margin-top: 8px;
}

.BC-Page__PreOrderGeneralSettings .heading .preview {
  font-size: 16px;
  justify-content: center;
}

.BC-Page__PreOrderGeneralSettings .preview > div {
  padding: 16px 40px;
  display: grid;
  gap: 24px;
}

.BC-Page__PreOrderGeneralSettings .preview .blocks > div:not(:last-child) {
  background: #f0f0f0;
  width: 100%;
  border-radius: 4px;
}

.BC-Page__PreOrderGeneralSettings .preview .blocks > div:nth-child(1) {
  max-width: 355px;
  height: 36px;
  opacity: 0px;
}

.BC-Page__PreOrderGeneralSettings .preview .blocks > div:nth-child(2) {
  max-width: 103px;
  height: 28px;
  margin-top: 8px;
}

.BC-Page__PreOrderGeneralSettings .preview .blocks > div:nth-child(3) {
  max-width: 71px;
  height: 20px;
  margin-top: 24px;
}

.BC-Page__PreOrderGeneralSettings .preview .blocks > div:nth-child(4) {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.BC-Page__PreOrderGeneralSettings .preview .blocks > div:nth-child(4) > div {
  width: 80px;
  height: 36px;
  border-radius: 20px;
  background-color: #f0f0f0;
}

.BC-Page__PreOrderGeneralSettings .preview .payment {
  padding: 12px 16px;
  border: 1px solid #4e4e4e;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.BC-Page__PreOrderGeneralSettings .preview .payment > p {
  align-items: end;
  text-align: right;
}

.BC-Page__PreOrderGeneralSettings .preview .payment > div > p {
  text-align: right;
}

.BC-Page__PreOrderGeneralSettings .preview .action .btn {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 12px;
  border: 1px solid #4e4e4e;
  border-radius: 100px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/pre-order-campaign.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC,0BAA0B;AAC1B;EACE,aAAa;EACb,sCAAsC;EACtC,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;AACA,oBAAoB;;AAEpB;EACE,eAAe;EACf,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;;EAIE,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,4EAA4E;EAC5E,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,WAAW;AACb;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,yBAAyB;EACzB,oBAAoB;AACtB","sourcesContent":["/* Css for pre-order campaign feature */\n/* -- management page -- */\n.BC-Page__Pre-Order-CampaignManagement .BC-Filters {\n  padding: 20px;\n  border-bottom: var(--p-border-divider);\n  display: grid;\n  gap: 10px;\n}\n\n.BC-PreOder--Filters {\n  display: flex;\n  gap: 8px;\n}\n\n.BC-PreOder--Filters .search {\n  flex: 1 1 auto;\n}\n\n.BC-PreOder--Filters--Popover {\n  width: 276px;\n  height: 100%;\n}\n\n.BC-PreOder--Filters--Popover .Polaris-ChoiceList__Title,\n.BC-PreOder--Filters--Popover .Polaris-Label__Text {\n  font-weight: 500;\n}\n\n.BC-PreOder--Filters--Popover .Polaris-ChoiceList__Title,\n.BC-PreOder--Filters--Popover .Polaris-Labelled__LabelWrapper {\n  margin-bottom: 8px;\n}\n\n.BC-PreOder--Filters--Popover ul {\n  display: flex;\n  gap: 20px;\n}\n\n.BC-PreOder--Filters--Popover .breakLine {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 16px;\n}\n\n.list-campaigns {\n  padding: 0;\n}\n\n.list-campaigns td {\n  padding: 20px;\n}\n\n.list-campaigns .Polaris-Button--plain svg {\n  fill: var(--p-icon);\n}\n\n.list-campaigns .Polaris-Badge {\n  padding: 2px 8px;\n  border-radius: 8px;\n  width: 54px;\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  font-weight: 500;\n}\n\n.list-campaigns .Polaris-Badge--statusAttention {\n  background: rgba(255, 214, 164, 1);\n  color: rgba(94, 66, 0, 1);\n}\n\n.list-campaigns .Polaris-Badge--statusNew {\n  color: rgba(97, 97, 97, 1);\n}\n\n.list-campaigns .Polaris-Badge--statusInfo {\n  background: rgba(224, 240, 255, 1);\n  color: rgba(0, 82, 124, 1);\n}\n\n.list-campaigns table tbody tr:not(:first-child) td {\n  border-top: var(--p-border-divider);\n}\n\n.BC-Page__Pre-Order-CampaignManagement [aria-label='Pagination'] {\n  padding: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.BC-Page__Pre-Order-CampaignManagement .Polaris-PageActions {\n  margin-top: 24px;\n  border-top: none;\n}\n\n.BC-Page__Pre-Order-CampaignManagement .pfs-banner-detail .pfs-banner-content {\n  width: 63% !important;\n}\n\n.preOrderGuideBanner .pfs-banner-detail .image {\n  margin-left: 20px !important;\n  margin-top: -20px !important;\n}\n\n.preOrderGuideBanner.pfs-banner-detail .image img {\n  margin-top: -20px;\n  max-width: 208px;\n}\n\n@media (max-width: 708px) {\n  .preOrderGuideBanner .pfs-banner-content > div:first-child {\n    min-height: 130px !important;\n  }\n}\n\n@media (max-width: 619px) {\n  .preOrderGuideBanner .pfs-banner-content > div:first-child {\n    min-height: 150px !important;\n  }\n}\n\n@media (max-width: 455px) {\n  .preOrderGuideBanner .pfs-banner-content > div:first-child {\n    min-height: 170px !important;\n  }\n}\n\n@media (max-width: 423px) {\n  .preOrderGuideBanner .pfs-banner-content > div:first-child {\n    min-height: 200px !important;\n  }\n}\n\n.BC-Page__Pre-Order-CampaignManagement .pfs-feature-lock-card {\n  padding: 50px 93px;\n  margin: unset;\n}\n\n.BC-EmptySearch__PreOrder {\n  text-align: center;\n  padding: 80px 112px;\n}\n\n.BC-EmptySearch__PreOrder img {\n  max-width: 45px;\n  height: auto;\n  margin-bottom: 16px;\n}\n/* -- view page -- */\n\n.PreOrder-Campaign__GeneralSettings .text-subdued {\n  font-size: 14px;\n  color: rgba(109, 113, 117, 1);\n  margin-top: 4px;\n}\n\n.BC-Page__Pre-Order-CampaignItem .render-choice-2 .Polaris-ChoiceList__Choices li {\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n  padding: 5px 0;\n}\n\n.BC-Page__Pre-Order-CampaignItem\n  .render-choice-2\n  .Polaris-ChoiceList__Choices\n  .Polaris-ChoiceList__ChoiceChildren {\n  margin-bottom: unset;\n}\n.BC-Page__Pre-Order-CampaignItem .Polaris-SkeletonPage__Page {\n  margin-top: 52px;\n}\n\n.BC-Page__Pre-Order-CampaignItem\n  .Polaris-SkeletonPage__Page\n  .Polaris-SkeletonDisplayText__DisplayText {\n  margin-bottom: 20px;\n}\n\n.BC-Page__Pre-Order-CampaignItem .render-choice-2 {\n  padding-bottom: 0;\n}\n\n.PreOrder-Campaign__GeneralSettings .settings {\n  display: grid;\n  gap: 24px;\n}\n\n.PreOrder-Campaign__GeneralSettings .settings .content {\n  padding: 4px 16px 0;\n  display: grid;\n  gap: 8px;\n}\n\n.PreOrder-Campaign__GeneralSettings .Polaris-ChoiceList ul li {\n  margin-top: 4px;\n}\n\n.PreOrder-Campaign__GeneralSettings .product-settings {\n  display: flex;\n  gap: 12px;\n}\n\n.PreOrder-Campaign__GeneralSettings .settings .stock-condition .Polaris-Connected {\n  width: 30%;\n  margin-top: 8px;\n}\n.PreOrder-Campaign__GeneralSettings .product-settings > div:first-child {\n  width: 35%;\n}\n\n.PreOrder-Campaign__GeneralSettings .product-settings > div:last-child {\n  flex: 1 1 auto;\n}\n\n.PreOrder-Campaign__GeneralSettings .product-list {\n  border: 1px dashed rgba(225, 227, 229, 1);\n  border-radius: 8px;\n  position: relative;\n}\n\n.PreOrder-Campaign__GeneralSettings .product-list .show-more {\n  border: unset !important;\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);\n  height: 56px;\n}\n\n.PreOrder-Campaign__GeneralSettings .product-list .show-more .Polaris-Button {\n  height: 40px;\n  background-color: #ffffff;\n}\n\n.PreOrder-Campaign__GeneralSettings .product-list .show-less {\n  height: 56px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.PreOrder-Campaign__GeneralSettings .product-list .show-less .Polaris-Button__Content,\n.PreOrder-Campaign__GeneralSettings .product-list .show-more .Polaris-Button__Content {\n  color: #2c6ecb;\n}\n\n.PreOrder-Campaign__GeneralSettings .product-list > div:not(:first-child) {\n  border-top: var(--p-border-divider);\n}\n\n.PreOrder-Campaign__GeneralSettings .product-list .product-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 16px;\n}\n\n.PreOrder-Campaign__GeneralSettings .product-list .product-item__Thumbnail,\n.PreOrder-Campaign__GeneralSettings .product-list .product-item__Action {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.PreOrder-Campaign__PaymentAndDiscount .settings {\n  display: grid;\n  gap: 24px;\n}\n\n.PreOrder-Campaign__PaymentAndDiscount .settings .content {\n  padding: 4px 16px 0;\n  display: grid;\n  gap: 8px;\n}\n\n.PreOrder-Campaign__PaymentAndDiscount .settings .content .row {\n  display: flex;\n  gap: 24px;\n}\n\n.PreOrder-Campaign__PaymentAndDiscount .settings .content .row-discount {\n  align-items: end;\n}\n\n.PreOrder-Campaign__PaymentAndDiscount .settings .content .row > div:first-child {\n  width: 35%;\n}\n\n.PreOrder-Campaign__PaymentAndDiscount .settings .content .row.one-column > div:first-child {\n  width: 100%;\n}\n\n.PreOrder-Campaign__PaymentAndDiscount .settings .content .row.two-column > div:nth-child(2) {\n  width: 180px;\n  max-width: 180px;\n}\n\n.PreOrder-Campaign__PaymentAndDiscount .settings .content .one-column > div > div:nth-child(2) {\n  width: 35%;\n}\n\n.PreOrder-Campaign__PaymentAndDiscount .date-select .Polaris-Button__Content {\n  position: relative;\n}\n.PreOrder-Campaign__PaymentAndDiscount .date-select button {\n  padding-right: 15px;\n}\n.PreOrder-Campaign__PaymentAndDiscount .date-select .Polaris-Button__Text {\n  display: flex;\n  align-items: center;\n}\n\n.PreOrder-Campaign__PaymentAndDiscount .date-select .Polaris-Button__Text > svg {\n  position: absolute;\n  right: 0;\n  width: 6px;\n  height: 12px;\n}\n\n.BC-PreOrderItem__Placement .Polaris-Link {\n  display: inline-flex;\n  gap: 2px;\n  color: #2c6ecb;\n}\n\n.BC-PreOrderItem__Placement .Polaris-Link .Polaris-Icon {\n  margin: 0;\n  width: 16px;\n  height: 16px;\n}\n\n.BC-PreOrderItem__Placement .heading {\n  display: grid;\n  gap: 12px;\n}\n\n.BC-PreOrderItem__Placement .heading .Polaris-Badge {\n  padding: 2px 8px;\n  height: 20px;\n  border-radius: 8px;\n}\n\n.BC-PreOrderItem__Placement .heading > p:first-child {\n  font-size: 28px;\n  line-height: 32px;\n  font-weight: 600;\n}\n\n.BC-PreOrderItem__Placement .heading > p:last-child {\n  font-size: 20px;\n  line-height: 28px;\n  font-weight: 600;\n}\n\n.BC-PreOrderItem__Placement .setup-content,\n.BC-PreOrderItem__Placement .Polaris-Card__Section {\n  display: grid;\n  gap: 32px;\n}\n\n.BC-PreOrderItem__Placement .action .content,\n.BC-PreOrderItem__Placement .action {\n  margin-top: 16px;\n}\n\n.BC-PreOrderItem__Placement .action .non-action {\n  display: flex;\n  gap: 12px;\n}\n\n.BC-PreOrderItem__Placement .action .non-action .Polaris-Icon {\n  margin: unset;\n}\n\n.BC-PreOrder--ProductModal li {\n  display: flex;\n  justify-content: space-between;\n}\n\n.BC-PreOrder--ProductModal .list-available {\n  padding-right: 10px;\n}\n\n.BC-PreOrder--ProductModal .list-available .variant {\n  padding-left: 28px;\n  margin-bottom: 12px;\n}\n.BC-PreOrder--ProductModal .list-available .variant li {\n  padding: 10px 0;\n}\n\n.BC-PreOrder--ProductModal .list-available .variant .BC-ProductItem__Checkbox {\n  display: flex;\n  position: relative;\n  top: 1px;\n}\n\n.BC-PreOrder--ProductModal .list-available .BC-ProductItem__Checkbox .Polaris-Choice__Control {\n  margin-right: 0;\n}\n\n.PreOrder-Campaign__GeneralSettings .product-list .variant .product-item {\n  border-top: var(--p-border-divider);\n}\n\n.PreOrder-Campaign__GeneralSettings .product-list .product-item__Action svg {\n  fill: #8c9196;\n}\n\n/* general settings */\n.BC-Page__PreOrderGeneralSettings .pfs-banner-detail .image {\n  margin-top: -14px;\n}\n\n.BC-Page__PreOrderGeneralSettings .general-settings {\n  border: 1px solid #e1e3e5;\n  border-radius: 8px;\n  width: 100%;\n  background-color: #ffffff;\n}\n\n.BC-Page__PreOrderGeneralSettings .general-settings .pfs-feature-lock-card {\n  margin: 60px;\n}\n\n.BC-Page__PreOrderGeneralSettings .general-settings .pfs-feature-lock-card .content {\n  display: flex;\n  justify-content: center;\n}\n\n.BC-Page__PreOrderGeneralSettings .general-settings .heading,\n.BC-Page__PreOrderGeneralSettings .general-settings .content {\n  display: flex;\n  width: 100%;\n}\n\n.BC-Page__PreOrderGeneralSettings .general-settings .heading > div,\n.BC-Page__PreOrderGeneralSettings .general-settings .content > div {\n  width: 50%;\n}\n\n.BC-Page__PreOrderGeneralSettings .general-settings .heading > div:first-child,\n.BC-Page__PreOrderGeneralSettings .general-settings .content > div:first-child {\n  border-right: 1px solid #e1e3e5;\n}\n\n.BC-Page__PreOrderGeneralSettings .general-settings .content > div {\n  height: 444px;\n}\n\n.BC-Page__PreOrderGeneralSettings .general-settings .heading > div {\n  padding: 18px 20px;\n  display: flex;\n  line-height: 24px;\n  align-items: center;\n  border-bottom: 1px solid #e1e3e5;\n}\n\n.BC-Page__PreOrderGeneralSettings .heading > div:first-child {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.BC-Page__PreOrderGeneralSettings .display-settings {\n  padding: 16px 20px;\n}\n\n.BC-Page__PreOrderGeneralSettings .display-settings .Polaris-Choice {\n  margin-top: 15px;\n}\n.BC-Page__PreOrderGeneralSettings .display-settings > div:last-child {\n  margin-top: 8px;\n}\n\n.BC-Page__PreOrderGeneralSettings .heading .preview {\n  font-size: 16px;\n  justify-content: center;\n}\n\n.BC-Page__PreOrderGeneralSettings .preview > div {\n  padding: 16px 40px;\n  display: grid;\n  gap: 24px;\n}\n\n.BC-Page__PreOrderGeneralSettings .preview .blocks > div:not(:last-child) {\n  background: #f0f0f0;\n  width: 100%;\n  border-radius: 4px;\n}\n\n.BC-Page__PreOrderGeneralSettings .preview .blocks > div:nth-child(1) {\n  max-width: 355px;\n  height: 36px;\n  opacity: 0px;\n}\n\n.BC-Page__PreOrderGeneralSettings .preview .blocks > div:nth-child(2) {\n  max-width: 103px;\n  height: 28px;\n  margin-top: 8px;\n}\n\n.BC-Page__PreOrderGeneralSettings .preview .blocks > div:nth-child(3) {\n  max-width: 71px;\n  height: 20px;\n  margin-top: 24px;\n}\n\n.BC-Page__PreOrderGeneralSettings .preview .blocks > div:nth-child(4) {\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.BC-Page__PreOrderGeneralSettings .preview .blocks > div:nth-child(4) > div {\n  width: 80px;\n  height: 36px;\n  border-radius: 20px;\n  background-color: #f0f0f0;\n}\n\n.BC-Page__PreOrderGeneralSettings .preview .payment {\n  padding: 12px 16px;\n  border: 1px solid #4e4e4e;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.BC-Page__PreOrderGeneralSettings .preview .payment > p {\n  align-items: end;\n  text-align: right;\n}\n\n.BC-Page__PreOrderGeneralSettings .preview .payment > div > p {\n  text-align: right;\n}\n\n.BC-Page__PreOrderGeneralSettings .preview .action .btn {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  padding: 12px;\n  border: 1px solid #4e4e4e;\n  border-radius: 100px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
